import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px;
  color: var(--text);
`;

const Title = styled.div`
  font-size: 18px;
  margin-right: 20px;

  a {
    color: var(--text);
  }
`;

const Stats = styled.div`
  color: var(--text-soft);
  font-size: 14px;
`;

const RemainingValue = styled.span<{ bump: boolean }>`
  color: ${({ bump }) => (bump ? 'var(--celebration)' : 'var(--text)')};
  display: inline-block;
  font-weight: 800;
  min-width: 3ch;
  transform-origin: center;

  ${({ bump }) =>
    bump &&
    `
      animation: remaining-bump 420ms ease-out;
    `}
`;

function Header({
  remaining,
  guesses,
  limit,
}: {
  remaining: number;
  guesses: number;
  limit: number;
}) {
  const previousRemaining = useRef(remaining);
  const [bumpRemaining, setBumpRemaining] = useState(false);

  useEffect(() => {
    if (remaining < previousRemaining.current) {
      setBumpRemaining(false);
      window.requestAnimationFrame(() => {
        setBumpRemaining(true);
      });
    }

    previousRemaining.current = remaining;
  }, [remaining]);

  useEffect(() => {
    if (!bumpRemaining) return;

    const timeout = window.setTimeout(() => {
      setBumpRemaining(false);
    }, 430);

    return () => window.clearTimeout(timeout);
  }, [bumpRemaining]);

  return (
    <Container>
      <Title>
        Kilordle by{' '}
        <a
          href="https://github.com/AllenZLink/Kilordle"
          rel="noreferrer"
          target="_blank"
        >
          AllenZlink
        </a>
      </Title>
      <Stats>
        Guesses: {guesses}/{limit} | Remaining:{' '}
        <RemainingValue bump={bumpRemaining}>{remaining}</RemainingValue>/1000
      </Stats>
    </Container>
  );
}

export default Header;
